var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-provider',{attrs:{"name":"label"}},[_c('b-form-input',{attrs:{"type":"text","name":_vm.name,"placeholder":_vm.placeholder,"state":_vm.state,"disabled":_vm.disabled,"formatter":_vm.formatterLocal},model:{value:(_vm.form[_vm.name]),callback:function ($$v) {_vm.$set(_vm.form, _vm.name, $$v)},expression:"form[name]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }